import { useState, useEffect } from "react";
import { SummarySession } from "../pages/SummarySession";
import { useParams } from "react-router-dom";
import { sendExtensionMessage } from "@sharpana/auth/api_client/allauth";

export default function ExtensionRequestSummary() {
  let { tabId } = useParams();

  const [sourceUrl, setSourceUrl] = useState("");
  const [contentToSummarize, setContentToSummarize] = useState(""); // This will come either from the browser extension or from the backend if using webapp without browser extension
  const [contentLength, setContentLength] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [showNoContentAvailableMsg, setShowNoContentAvailableMsg] =
    useState<boolean>(false);

  const webExtensionId = import.meta.env.VITE_CHROME_EXTENSION_ID;

  useEffect(() => {
    async function getUrlAndContent() {
      const response: any = await sendExtensionMessage(webExtensionId, {
        message: "getUrlAndContent",
        tabId: tabId,
      });
      console.log("Got response from extension getUrlAndContent request:");
      console.log(response);
      if (response && response.success && response.url && response.content) {
        setSourceUrl(response.url);
        setContentToSummarize(response.content);
        setContentLength(response.contentLength);
        // setSessionId(String(Date.now()));
        setSessionId("s");
        setShowNoContentAvailableMsg(false);
      } else {
        // TODO: Give the user the option to retry fetching url/content?
        const targetUrl = response.url;
        // TODO: Fetch content from backend instead
        setShowNoContentAvailableMsg(true);
      }
    }

    function windowReceivedMessage(e: MessageEvent) {
      // Need to check source of message before accepting/acting on payload
      // console.log("post message received --------- 22 33 !!!");
      // console.log(e);
      if (e.isTrusted && e.origin == `chrome-extension://${webExtensionId}`) {
        if (e.data == "requestNewSummarySource") {
          getUrlAndContent();
        }
      }
    }
    window.addEventListener("message", windowReceivedMessage, false);

    // The following helps avoid a re-render according to: https://stackoverflow.com/a/57856876
    if (!sourceUrl || !contentToSummarize) {
      setContentToSummarize(""); // TODO: This might need to be controlled via a "loading" state var, instead of using contentToSummarize for that dual purpose (showing loading indicator)
      getUrlAndContent();
    }

    return () => {
      window.removeEventListener("message", windowReceivedMessage);
    };
  }, []);

  return (
    <div>
      {contentToSummarize && sourceUrl && sessionId ? (
        // <div>{contentToSummarize}</div>
        <SummarySession
          contentToSummarize={String(contentToSummarize)}
          contentLength={contentLength}
          targetUrl={sourceUrl}
          sessionId={sessionId}
          tabId={tabId}
          summarizationMode="threadInsights"
          // TODO: FIX! Must pass the resourceId (ResourceContent.id) in order to associate the research session with the resource content (otherwise things like the 'user history' page won't be able to associate the session with the resource content)
          // summarizationMode="threadTimeline"
        />
      ) : (
        <>
          {showNoContentAvailableMsg ? (
            <div>
              <p>It seems like there's no transcript/content available yet! This usually happens with very new videos or some special sources.</p> 
              <p>We are working on making these work as well (shipping soon). In the meantime please
              try with a different video/url.</p>
            </div>
          ) : (
            <p>Loading...</p>
          )}
        </>
      )}
    </div>
  );
}
